import React from 'react';
import styled from 'styled-components';
import { H1 } from '@wco/toolkit';

const Container = styled.div`
  text-align: center;
`;

const Article = styled.article`
  margin-bottom: 3.125rem;
  text-align: left;
  padding: 3.125rem 2rem 2rem 2rem;
`;

const Header = styled.header`
  margin-bottom: 1.875rem;
  max-width: inherit;
  display: block;
`;

const Content = styled.div`
  margin-top: 1.875rem;
  max-width: none;
  width: auto;
`;

const Row = styled.div`
  max-width: none;
  width: auto;
`;

type errorMessage = {
  header: string;
  message: string;
};

export function NoMatch(props: errorMessage) {
  return (
    <Container>
      <Article>
        <Header>
          <H1>{props.header}</H1>
        </Header>
        <Content>
          <Row>
            <div>
              <div>{props.message}</div>
            </div>
          </Row>
        </Content>
      </Article>
    </Container>
  );
}
